import React, { useEffect, useState } from 'react'
import { graphql } from 'gatsby'
import { Office } from './mapper'
import MapWithPlaceholder from '../../ui/mapWithPlaceholder'

type FirmMapProps = {
  offices: Office[] | null
  googleMapsApiKey: string | null
  focusedAddress?: React.Dispatch<React.SetStateAction<{
    street: string;
    city: string;
    postalCode: string;
  } | null>>
  className?: string
  height?: number
}

const FirmMap: React.FC<FirmMapProps> = ({
  offices,
  googleMapsApiKey,
  focusedAddress = undefined,
  className,
  height = 396,
}) => {
  let locations: {
    latitude: number
    longitude: number
    postalCode: string
    street: string
    city: string
  }[] = []
  if (offices && offices.length > 0) {
    locations = offices.map((office) => ({
      latitude: office ? office.latitude || 0 : 0,
      longitude: office ? office.longitude || 0 : 0,
      street: office ? office.street || '' : '',
      city: office ? office.city || '' : '',
      postalCode: office ? office.postalCode || '' : '',
    }))
  }

  const [newHeight, setNewHeight] = useState(height)

  useEffect(() => {
    const container = document.getElementById('firm-map-container')
    if (container && container.getBoundingClientRect().height > height) {
      setNewHeight(container.getBoundingClientRect().height)
    }
  }, [focusedAddress])

  return (
    <div
      id="firm-map-container"
      className={`shadow-lg rounded-xl ${className}`}
      style={{ height: newHeight }}
    >
      <MapWithPlaceholder
        locations={locations}
        apiKey={googleMapsApiKey || ''}
        focusedAddress={focusedAddress}
        height={newHeight}
      />
    </div>
  )
}

export default FirmMap

export const query = graphql`
  fragment FirmMap on STRAPI_ACCOUNTING_FIRM {
    offices {
      id
      uuid
      latitude
      longitude
      postalCode
      name
      city
      street
    }
  }
`
